import { DecorationDto } from './decoration-dto';

export class LabelDto extends DecorationDto { }